import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb' 
const OurManager = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Our Patron" midBreadcrumb="School" mainBreadcrumb="Our Patron" ></Breadcrumb>
            <div  className='inner-page'>
                <div  className='container'>
                <div  className="col-12">
          <div  className="clearfix"> 
            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/parton.jpg" className="col-md-4 float-md-end rit-img img-des-thumb" alt="matamariamjansevavidyalayas" />
            <p><span>St. Mary Mother of God or the Virgin Mary</span> is believed by many to be the greatest of all Christian saints. The Virgin Mother “was, after her Son, exalted by divine grace above all angels and men.”</p>
            <p>Mary is venerated with a special cult, called by St. Thomas Aquinas, hyperdulia, as the holiest of all creatures. The main events of her life are celebrated as liturgical feasts of the universal Church.</p>
            <p>Mary’s life and role in the history of salvation is foreshadowed in the Old Testament, while the events of her life are recorded in the New Testament. Traditionally, she was declared the daughter of Sts. Joachim and Anne. Born in Jerusalem, Mary was presented in the Temple and took a vow of virginity. Living in Nazareth, Mary was visited by the archangel Gabriel, who announced to her that she would become the Mother of Jesus, by the Holy Spirit.</p>
            <p>She became betrothed to St. Joseph and went to visit her cousin, Elizabeth, who was bearing St. John the Baptist. Acknowledged by Elizabeth as the Mother of God, Mary intoned the Magnificat. When Emperor Augustus declared a census throughout the vast Roman Empire, Mary and St. Joseph went to Bethlehem, his city of lineage, as he belonged to the House of David. There Mary gave birth to Jesus and was visited by the Three Kings.</p>
            <p>Mary and Joseph presented Jesus in the Temple, where St. Simeon rejoiced and Mary received word of sorrows to come later. Warned to flee, St. Joseph and Mary went to Egypt to escape the wrath of King Herod. They remained in Egypt until King Herod died and then returned to Nazareth.
            </p>

            <p>Nothing is known of Mary’s life during the next years
              except for a visit to the Temple of Jerusalem, at
              which time Mary and Joseph sought the young Jesus, who was in the Temple with the learned elders.
            </p>

            <p>The first recorded miracle of Jesus was performed at a
              wedding in Cana, and Mary was instrumental in
              calling Christ’s attention to the need. Mary was present at the Crucifixion in Jerusalem, and there she
              was given into John the Apostle’s care. She was also with the disciples in the days before the Pentecost,
              and it is believed that she was present at the resurrection and Ascension.
            </p>


            <p>No scriptural reference concerns Mary’s last years on
              earth. According to tradition, she went to Ephesus,
              where she experienced her “dormition.” Another tradition states that she remained in Jerusalem. The belief
              that Mary’s body was assumed into heaven is one of the oldest traditions of the Catholic Church.
            </p>

            <p>Pope Pius XII declared this belief Catholic dogma in 1950.
              The four Catholic dogmas are: Mother of God,
              Perpetual virginity of Mary, the Immaculate Conception and Assumption of Mary. The feast of the Assumption
              is celebrated on August 15. The Assumption was the bodily taking up of the Virgin Mary into Heaven at the
              end of her earthly life. According to Pope Pius XII, the Virgin Mary “having completed the course of her
              earthly life, was assumed body and soul into heavenly glory.”
            </p>

            <p>In 1854, Pope Pius IX proclaimed the dogma of the
              Immaculate Conception – that Mary, as the Mother of the
              Second Person of the Holy Trinity, was free of original sin at the moment of her conception. The feast of
              the Immaculate Conception is celebrated on December 8. The birthday of Mary is an old feast in the Church,
              celebrated on September 8, since the seventh century.
            </p>

            <p>Other feasts that commemorate events in the life of the
              Blessed Virgin Mary are listed in the Appendices. Pope Pius XII dedicated the entire human race to Mary in 1944. The Church has long taught that Mary is
              truly the Mother of God.
            </p>

            <p>The Blessed Virgin Mary may be taken as a patroness of any
              good activity, for she is often cited as the
              patroness of all humanity. Mary is also associated with protecting many occupations and locations.
            </p>

            <p>St. Paul observed that “God sent His Son, born of a woman,”
              expressing the union of the human and the
              divine in Christ. As Christ possesses two natures, human and divine, Mary was the Mother of God in his
              human nature. This special role of Mary in salvation history is clearly shown in the Gospel where she is
              seen constantly at her son’s side during his soteriological mission. Because of this role, exemplified by
              her acceptance of Christ into her womb, her offering of him to God at the Temple, her urging him to
              perform his first miracle, and her standing at the foot of the Cross at Calvary Mary was joined fully in
              the sacrifice by Christ of himself.
            </p>

            <p>Pope Benedict XV wrote in 1918: “To such an extent did
              Mary
              suffer and almost die with her suffering and
              dying Son; to such extent did she surrender her maternal rights over her Son for man’s salvation, and
              immolated him – insofar as she could in order to appease the justice of God, that we might rightly say she
              redeemed the human race together with Christ.” Mary is entitled to the title of Queen because, as Pope
              Pius XII expressed it in a 1946 radio speech, “Jesus is King throughout all eternity by nature and by
              right of conquest: through him, with him, and subordinate to him, Mary is Queen by grace, by divine
              relationship, by right of conquest, and by singular election.” Mary possesses a unique relationship with
              all three Persons of the Trinity, thereby giving her a claim to the title of Queenship. She was chosen by
              God the Father to be the Mother of his Son; God the Holy Spirit chose her to be his virginal spouse for
              the Incarnation of the Son; and God the Son chose her to be his mother, the means of incarnating into the
              world for the purposes of the redemption of humanity.
            </p>

            <p>This Queen is also our Mother. While she is not our Mother
              in the physical sense, she is called a
              spiritual mother, for she conceives, gives birth, and nurtures the spiritual lives of grace for each
              person. As Mediatrix of All Graces, she is ever present at the side of each person, giving nourishment and
              hope, from the moment of spiritual birth at Baptism to the moment of death.
            </p>
            <p>In art, Mary is traditionall portrayed in blue. Her other
              attributes are a blue mantle, crown of 12
              stars, pregnant woman, roses, and/or woman with child.
            </p>
            <p>Hundreds of thousands of pieces of Marian artwork and
              sculptures have been created over the years from
              the best and most brilliant artists, like Michelangelo and Botticell, to simple peasant artists. Some of
              the most early examples of veneration of Mary is documented in the Catacombs of Rome. Catacomb paintings
              show Mary the Blessed Virgin with her son.
            </p>
            <p>The confidence that each person should have in Mary was
              expressed by Pope Pius IX in the encyclical
              Ubipriinum : “The foundation of all our confidence. . . is found in the Blessed Virgin Mary. For God has
              committed to Mary the treasury of all good things, in order that everyone may know that through her are
              obtained every hope, every grace, and all salvation. For this is his will, that we obtain everything
              through Mary.”
            </p>
          </div>
        </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default OurManager